import { createContext } from 'react'
import { GroupChannel, SendBirdInstance, UserMessage } from 'sendbird'

interface ISendbirdContextType {
  channels?: GroupChannel[]
  generateFallbackChannelName?: (channel: GroupChannel) => string
  isOwnMessage?: (message: UserMessage) => boolean
  lastUpdated: number
  sendBird?: SendBirdInstance
  status: string
  unreadMessageCount: number
  updateUnreadMessageCount: () => void
  fetchLatestGroupChannelWithUnreadMessages?: () => Promise<GroupChannel | undefined>
}
export default createContext<ISendbirdContextType>({
  lastUpdated: 0,
  status: 'none',
  unreadMessageCount: 0,
  updateUnreadMessageCount: () => undefined,
})
